import styled from "styled-components";
import { theme } from "../theme";

export const SettingsContainer = styled.div`
  background: ${theme.colors.background.primary};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.heavy};
  max-width: 500px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
`;

export const SettingsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing.lg};
  border-bottom: 1px solid ${theme.colors.border};
  
  h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: ${theme.colors.text.primary};
  }
`;

export const SettingsContent = styled.div`
  padding: ${theme.spacing.lg};
`;

export const SettingsSection = styled.div`
  margin-bottom: ${theme.spacing.xl};
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SettingsTitle = styled.h4`
  margin: 0 0 ${theme.spacing.md} 0;
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
`;

export const SettingsOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing.md};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.md};
  margin-bottom: ${theme.spacing.sm};
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SettingsLabel = styled.div`
  flex: 1;
  margin-right: ${theme.spacing.md};
`;

export const SettingsToggle = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  
  input {
    opacity: 0;
    width: 0;
    height: 0;
    
    &:checked + .slider {
      background: ${theme.colors.primary};
    }
    
    &:checked + .slider:before {
      transform: translateX(26px);
    }
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${theme.colors.text.secondary};
    transition: ${theme.transitions.normal};
    border-radius: 24px;
    
    &:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background: ${theme.colors.text.light};
      transition: ${theme.transitions.normal};
      border-radius: 50%;
    }
  }
`;

export const SettingsButton = styled.button<{ disabled?: boolean; $isBlocked?: boolean }>`
  background: ${props => props.$isBlocked ? theme.colors.warning : theme.colors.primary};
  color: ${theme.colors.text.light};
  border: none;
  border-radius: ${theme.borderRadius.sm};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  font-size: 0.875rem;
  font-weight: 500;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all ${theme.transitions.normal};
  opacity: ${props => props.disabled ? 0.6 : 1};
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const SettingsActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
  padding-top: ${theme.spacing.lg};
  border-top: 1px solid ${theme.colors.border};
`;

export const DangerZone = styled.div`
  border: 1px solid ${theme.colors.error};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.md};
  background: rgba(220, 53, 69, 0.05);
`;

export const DangerTitle = styled.h4`
  margin: 0 0 ${theme.spacing.md} 0;
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.error};
`;

export const DangerDescription = styled.p`
  margin: 0 0 ${theme.spacing.md} 0;
  font-size: 0.875rem;
  color: ${theme.colors.text.secondary};
`;

export const DangerButton = styled.button<{ disabled?: boolean }>`
  background: ${theme.colors.error};
  color: ${theme.colors.text.light};
  border: none;
  border-radius: ${theme.borderRadius.sm};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  font-size: 0.875rem;
  font-weight: 500;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all ${theme.transitions.normal};
  opacity: ${props => props.disabled ? 0.6 : 1};
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;
